/**
 * Keeps the "+ X лв." labels on option cards in sync with the other selected option.
 *
 * Every combination is rendered server side, one span per value of the source option,
 * and only visibility is toggled here. Rewriting the text would drop the secondary
 * currency that Shopify appends to rendered prices on load.
 *
 * The theme dispatches a non-bubbling `change` on option inputs, so listeners are
 * attached per input rather than delegated from the form.
 */
(function () {
  const selectors = {
    container: '[data-option-prices]',
    value: '[data-option-price-for]',
    optionSelector: '[data-single-option-selector]'
  };

  const classes = {
    active: 'is-active'
  };

  class OptionPrices {
    constructor(container) {
      this.container = container;
      this.form = container.closest('form') || container.closest('[data-product]');
      this.sourceIndex = container.getAttribute('data-option-price-source');

      if (!this.form || !this.sourceIndex) {
        return;
      }

      this.values = [...container.querySelectorAll(selectors.value)];
      this.inputs = [...this.form.querySelectorAll(`${selectors.optionSelector}[data-index="${this.sourceIndex}"]`)];

      if (!this.values.length || !this.inputs.length) {
        return;
      }

      this.onChange = this.update.bind(this);
      this.inputs.forEach((input) => input.addEventListener('change', this.onChange));

      this.update();
    }

    /**
     * Current value of the option the prices depend on.
     * Radios expose it through :checked, popout selects through a hidden input.
     * @returns {String|null}
     */
    getSourceValue() {
      const input = this.inputs.find((element) => element.type !== 'radio' || element.checked);

      return input ? input.value : null;
    }

    /**
     * Show the price belonging to the current source value, hide the rest.
     */
    update() {
      const sourceValue = this.getSourceValue();

      this.values.forEach((element) => {
        element.classList.toggle(classes.active, element.getAttribute('data-option-price-for') === sourceValue);
      });
    }
  }

  const init = () => {
    document.querySelectorAll(selectors.container).forEach((container) => {
      if (container.dataset.optionPricesReady) return;

      container.dataset.optionPricesReady = 'true';
      new OptionPrices(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
